(function () {
  const root = document.querySelector('[data-fdl-root]');
  if (!root) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('fdl--enhanced');

  const reptileImg =
    'https://images.unsplash.com/photo-1760634871892-8b2d3b52ace6?auto=format&fit=crop&w=600&q=80';
  root.querySelectorAll('.pdeal').forEach((card) => {
    const title = card.querySelector('.pdeal__body h3');
    const img = card.querySelector('img.fdl-img');
    if (!img || !title || title.textContent.trim().toLowerCase() !== 'reptile') return;
    if (img.src.includes('1518796251428')) img.src = reptileImg;
  });

  root.querySelectorAll('img.fdl-img').forEach((img) => {
    const ph = img.closest('.ph');
    const done = () => img.classList.add('is-loaded');
    const onError = () => {
      const card = img.closest('.pdeal');
      const title = card && card.querySelector('.pdeal__body h3');
      if (title && title.textContent.trim().toLowerCase() === 'reptile' && img.dataset.reptileFixed !== '1') {
        img.dataset.reptileFixed = '1';
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', () => {
          if (ph) ph.classList.add('ph--fallback');
        }, { once: true });
        img.src = reptileImg;
        return;
      }
      const fb = img.getAttribute('data-fallback-src');
      if (fb && img.dataset.fallbackUsed !== '1') {
        img.dataset.fallbackUsed = '1';
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', () => {
          if (ph) ph.classList.add('ph--fallback');
        }, { once: true });
        img.src = fb;
        return;
      }
      if (ph) ph.classList.add('ph--fallback');
    };
    if (img.complete && img.naturalWidth > 0) done();
    else {
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', onError);
    }
  });

  root.querySelectorAll('[data-fdl-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const code = btn.getAttribute('data-fdl-copy') || '';
      try {
        await navigator.clipboard.writeText(code);
      } catch (e) { /* noop */ }
      btn.textContent = 'Copied ✓';
      btn.classList.add('copied');
      setTimeout(() => {
        btn.textContent = 'Copy code';
        btn.classList.remove('copied');
      }, 1900);
    });
  });

  const cd = root.querySelector('[data-fdl-countdown]');
  if (cd) {
    const pad = (n) => String(n).padStart(2, '0');
    const endAttr = cd.getAttribute('data-end');
    let end = endAttr ? Date.parse(endAttr) : NaN;
    if (!end || Number.isNaN(end)) {
      const days = parseInt(cd.getAttribute('data-fallback-days'), 10) || 6;
      end = Date.now() + days * 86400000 + 8 * 3600000;
    }
    const tick = () => {
      let diff = Math.max(0, end - Date.now());
      const d = Math.floor(diff / 86400000);
      diff -= d * 86400000;
      const h = Math.floor(diff / 3600000);
      diff -= h * 3600000;
      const m = Math.floor(diff / 60000);
      diff -= m * 60000;
      const s = Math.floor(diff / 1000);
      const elD = cd.querySelector('[data-d]');
      const elH = cd.querySelector('[data-h]');
      const elM = cd.querySelector('[data-m]');
      const elS = cd.querySelector('[data-s]');
      if (elD) elD.textContent = pad(d);
      if (elH) elH.textContent = pad(h);
      if (elM) elM.textContent = pad(m);
      if (elS) elS.textContent = pad(s);
    };
    tick();
    setInterval(tick, 1000);
  }

  const tabs = root.querySelector('[data-fdl-tabs]');
  const cards = [...root.querySelectorAll('[data-fdl-sale-grid] .scard')];
  if (tabs && cards.length) {
    const counts = { all: cards.length, under25: 0, big: 0, clearance: 0 };
    cards.forEach((c) => {
      const tags = (c.getAttribute('data-tags') || '').split(/\s+/).filter(Boolean);
      if (tags.includes('under25')) counts.under25 += 1;
      if (tags.includes('big')) counts.big += 1;
      if (tags.includes('clearance')) counts.clearance += 1;
    });
    Object.keys(counts).forEach((k) => {
      const el = tabs.querySelector(`[data-fdl-count="${k}"]`);
      if (el) el.textContent = counts[k];
    });
    tabs.addEventListener('click', (e) => {
      const btn = e.target.closest('.tab');
      if (!btn) return;
      tabs.querySelectorAll('.tab').forEach((t) => t.classList.remove('on'));
      btn.classList.add('on');
      const f = btn.getAttribute('data-filter');
      cards.forEach((c) => {
        const show = f === 'all' || (c.getAttribute('data-tags') || '').split(/\s+/).includes(f);
        c.classList.toggle('hide', !show);
      });
    });
  }

  const sort = root.querySelector('[data-fdl-sort]');
  const grid = root.querySelector('[data-fdl-sale-grid]');
  if (sort && grid) {
    sort.addEventListener('change', () => {
      const items = [...grid.querySelectorAll('.scard')];
      const mode = sort.value;
      items.sort((a, b) => {
        if (mode === 'price-asc') return (+a.dataset.price || 0) - (+b.dataset.price || 0);
        if (mode === 'newest') return 0;
        return (+b.dataset.pct || 0) - (+a.dataset.pct || 0);
      });
      items.forEach((el) => grid.appendChild(el));
    });
  }

  root.querySelectorAll('[data-fdl-acc] .acc__q').forEach((q) => {
    q.addEventListener('click', () => {
      const item = q.parentElement;
      const a = item.querySelector('.acc__a');
      const open = item.classList.contains('open');
      root.querySelectorAll('[data-fdl-acc] .acc__item').forEach((i) => {
        i.classList.remove('open');
        const panel = i.querySelector('.acc__a');
        if (panel) panel.style.maxHeight = null;
      });
      if (!open) {
        item.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  root.querySelectorAll('[data-fdl-wish]').forEach((b) => {
    b.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      b.classList.toggle('is-on');
    });
  });

  const fillBar = () => {
    root.querySelectorAll('[data-fdl-stockfill]').forEach((f) => {
      f.style.width = f.getAttribute('data-fill') || '0%';
    });
  };

  const items = root.querySelectorAll('[data-reveal]');
  if (reduced || !('IntersectionObserver' in window)) {
    items.forEach((el) => el.classList.add('in'));
    fillBar();
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        io.unobserve(e.target);
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  items.forEach((el) => io.observe(el));
  const sf = root.querySelector('[data-fdl-stockfill]');
  if (sf) {
    const sb = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            fillBar();
            sb.disconnect();
          }
        });
      },
      { threshold: 0.4 }
    );
    sb.observe(sf);
  }
})();
